import { createSlice } from '@reduxjs/toolkit';

export type colourType = "both"|"normal"|"inverted";

export interface OtherSettings {
  textCount: number | "auto";
  colour: colourType;
};
const initialState: OtherSettings = {
  textCount: 999,
  colour: "both"
}

const advancedSettingsSlice = createSlice({
  name: 'otherSettings',
  initialState,
  reducers: {
    updateOtherSettings: (state, action) => {
      (state as any)[action.payload.type] = action.payload.value;
    },
    updateMultiSettings: (state, action) => {
      if(action.payload.textCount === 0) {
        action.payload.textCount = "auto";
      }
      state = action.payload;
      return state;
    }
  },
});

export const { updateOtherSettings, updateMultiSettings } = advancedSettingsSlice.actions;

export default advancedSettingsSlice.reducer;